import { useLocation } from "react-router-dom";
import privateRoutes from "src/routes/private-routes";

import DepositAutoWithdrawalActive from "src/components/DepositStatusBanner/DepositAutoWithdrawalActive";
import DepositAutoWithdrawalInactive from "src/components/DepositStatusBanner/DepositAutoWithdrawalInactive";
import DepositStatusInactive from "src/components/DepositStatusBanner/DepositStatusInactive";
// TEMP (2026-10-28): company bank account add/edit hidden while platform abuse is handled. Uncomment to restore.
// import DepositBankCompany from "src/scenes/MyDeposit/components/Overview/DepositBankCompany";

import { DEPOSIT_ACTIVATION_STATUS } from "src/consts/deposit";
import { useSelector } from "src/hooks/state";
import { useUserInfo } from "src/hooks/user";
import useTrialInfo from "src/scenes/Home/hooks/useTrialInfo";
import useDepositAutoWithdrawalBanner from "../hooks/useDepositAutoWithdrawalBanner";

function DepositAutoWithdrawalBanner() {
  const { pathname } = useLocation();
  const { user, isDoneLoading, isDepositInactive, isKYCDone } = useUserInfo();
  const { isTrialActive } = useTrialInfo();
  const { state } = useDepositAutoWithdrawalBanner();
  const isAdmin = useSelector(({ commonUser }) => commonUser.isAdmin);
  // TEMP (2026-10-28): company bank account add/edit hidden while platform abuse is handled. Uncomment to restore.
  // const { showModalActivation, isLoading } = state;
  // const { setState } = methods;
  const { isLoading } = state;

  const isDepositBlocked = user.company?.deposit_status === DEPOSIT_ACTIVATION_STATUS.BLOCKED;
  const isDepositRejected = user.company?.deposit_status === DEPOSIT_ACTIVATION_STATUS.REJECTED;
  const pathnameHome = pathname === privateRoutes.home.path;

  if (
    ![privateRoutes.deposit.path, privateRoutes.home.path].includes(pathname) ||
    !isDoneLoading ||
    isLoading ||
    isDepositBlocked ||
    isDepositRejected
  )
    return null;

  function renderDepositBanner() {
    if (isDepositBlocked || isDepositRejected) return null;

    // *user has disabled deposit
    if (isAdmin && isDepositInactive && pathnameHome && (isTrialActive || isKYCDone)) {
      // TEMP (2026-10-28): company bank account add/edit hidden while platform abuse is handled. Uncomment to restore.
      // return <DepositStatusInactive onClickActivateDeposit={() => setState({ showModalActivation: true })} />;
      return <DepositStatusInactive />;
    }

    if (isDepositInactive) return null;

    // *user has configuration and enabled the auto withdrawal option
    if (state.depositAutoWithdrawalResponse?.is_active || state.depositAutoWithdrawalResponse?.is_active === null) {
      return <DepositAutoWithdrawalActive />;
    }

    // *user doesn't have configuration saved*
    return <DepositAutoWithdrawalInactive />;
  }

  return (
    <>
      {renderDepositBanner()}
      {/* TEMP (2026-10-28): company bank account add/edit hidden while platform abuse is handled. Uncomment to restore.
      <DepositBankCompany show={showModalActivation} toggle={(value) => setState({ showModalActivation: value })} />
      */}
    </>
  );
}

export default DepositAutoWithdrawalBanner;
